import { Stack } from '@mantine/core';

import {
  ResourceAssistantChat, type ViewSelectorProps
} from '../../../components';
import classes from './AssistantView.module.css';
import EditorPaneContainer from './EditorPaneContainer';
type Props = ViewSelectorProps;

const AssistantView: React.FC<Props> = (props: Props) => (
  <Stack gap={0} flex={1}>
    <EditorPaneContainer {...props}>
      <ResourceAssistantChat
        style={{ flex: 1, minHeight: 0 }}
        classNames={{
          root: classes.assistantRoot,
          bottomContainer: classes.bottomContainer
        }}
      />
    </EditorPaneContainer>
  </Stack>
);

export default AssistantView;
